import React, { useState } from "react";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import api from "../../api/axios";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { CommonButton } from "../../components/common/CommonButton";
import { CommonInput } from "../../components/common/CommonInput";

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [values, setValues] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!values.email || !values.password) {
      setError("Email and password are required");
      return;
    }

    setIsLoading(true);
    try {
      const res = await api.post("/auth/login", values);
      const user = res.data?.data?.user;
      const token = res.data?.data?.token;

      if (user && token) {
        login(user, token);

        if (user.role === "admin") navigate("/admin/dashboard");
        else if (user.role === "client") navigate("/client/dashboard");
      }
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || "Invalid credentials or server error";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="surface-100 min-h-screen flex justify-content-center align-items-center"
      style={{ backgroundColor: "#f5f5f5", position: 'relative' }}
    >
      {isLoading && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.8)', zIndex: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ProgressSpinner />
        </div>
      )}
      <Card
        className="p-4 p-rounded p-shadow-6"
        style={{
          width: "400px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
        }}
      >
        <h2 className="text-center mb-3" style={{ color: "#FA5813FF" }}>
          Login
        </h2>

        <form onSubmit={handleSubmit} className="p-fluid flex flex-column gap-4">
          <CommonInput
            label="Email"
            type="email"
            name="email"
            value={values.email}
            placeholder="Enter your email"
            onChange={handleChange}
            autoComplete="email"
          />
          <CommonInput
            label="Password"
            type="password"
            name="password"
            value={values.password}
            placeholder="Enter your password"
            onChange={handleChange}
            autoComplete="current-password"
          />

          {error && <small style={{ color: "red" }}>{error}</small>}

          <CommonButton
            type="submit"
            label="Login"
            theme={{ bgColor: "#FA5813FF", textColor: "#fff", fontWeight: "bold" }}
          />
        </form>

        <div className="mt-3 text-center">
          <span>Don't have an account? </span>
          <span
            onClick={() => navigate("/signup")}
            style={{ color: "#FA5813FF", fontWeight: "bold", cursor: "pointer" }}
          >
            Sign Up
          </span>
        </div>
      </Card>
    </div>
  );
}
